import { Component, OnInit } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-select-input',
    standalone: false,
    templateUrl: './select-input.component.html',
    styleUrl: './select-input.component.scss',
})
export class SelectInputComponent extends InputComponent implements OnInit {
    selectedOptions: string;

    ngOnInit(): void {
        this.subscriptions.add(
            this.fc.valueChanges.subscribe(() => {
                if (this.fc.value === null || this.fc.value === undefined) {
                    return;
                }

                if (Array.isArray(this.fc.value)) {
                    this.selectedOptions = this.fc.value
                        .map((d: string) => this.field.options.find(o => o.key === d)?.name.substring(0, 2))
                        .filter((n: string) => n)
                        .join(', ');
                }
            })
        );
    }
}
